import queryString from 'qs'

import useGoogleMapsScriptLoadedRef from 'hooks/useGoogleMapsScriptLoadedRef'

import Button from '../../../components/display/Button'
import InlineSpinner from '../../../components/display/InlineSpinner'
import {
  getFiltersFromBounds,
  LocationToLatLngBounds,
} from '../../../utils/geo'

interface LinkToEntitiesNearLocationProps {
  entityType: 'accommodation' | 'adventures'
  location: { lat: number; lng: number }
}

const LinkToEntitiesNearLocation = ({
  entityType,
  location,
}: LinkToEntitiesNearLocationProps) => {
  const googleMapsLoaded = useGoogleMapsScriptLoadedRef()

  if (googleMapsLoaded.current !== true) {
    return <InlineSpinner />
  }

  const bounds = LocationToLatLngBounds(
    {
      lat: location.lat,
      lng: location.lng,
    },
    50000, // radius in meters
    // https://developers.google.com/maps/documentation/javascript/using-typescript
    // @ts-ignore -- google maps api needs typing
    google.maps.Circle,
  )
  const locationFilters = getFiltersFromBounds(bounds)
  const discoverMorePlacesLink = `/listings?${queryString.stringify({
    type: entityType,
    ...locationFilters,
  })}`

  return (
    <a
      href={discoverMorePlacesLink}
      style={{ textDecoration: 'none' }}
      target="_blank"
      rel="noopener noreferrer"
    >
      <Button
        css="
            width: 240px;
            margin: auto;
          "
        ghost
      >
        Discover More
      </Button>
    </a>
  )
}

export default LinkToEntitiesNearLocation
